import {match} from 'ts-pattern';

type ResizeHandleProps = {
  /** Which edge of the header cell the handle sits on. */
  edge: 'LEFT' | 'RIGHT';
  onResizePointerDown: React.PointerEventHandler;
};

/**
 * Invisible pointer-grab area for column resize, spanning the full cell height.
 *
 * Positioned fully INSIDE the cell: the parent `<th>` has `overflow: hidden`, so any
 * part of the handle placed past the cell edge would be clipped and silently shrink
 * the effective hit target. The 1px indicator line is aligned to the cell edge and
 * highlighted via `group-hover` on this handle — the line itself is
 * `pointer-events-none` and can never match `:hover` on its own.
 *
 * `touch-none` disables native touch scrolling over the handle so pointer-based
 * drag resize also works on touch devices.
 *
 * The `data-resize-handle` attribute lets HeaderCell's sort click handler ignore
 * clicks that land on the handle (the cursor already shows `col-resize` there).
 */
export function ResizeHandle(props: ResizeHandleProps) {
  const edgeClass = match(props.edge)
    .with('LEFT', () => 'left-0 justify-start')
    .with('RIGHT', () => 'right-0 justify-end')
    .exhaustive();

  return (
    <span
      data-resize-handle={props.edge}
      className={`group/resize absolute top-0 h-full w-[7px] cursor-col-resize touch-none z-(--z-content-loader) flex items-stretch ${edgeClass}`}
      onPointerDown={props.onResizePointerDown}
    >
      <span className="w-px h-full group-hover/resize:bg-blue-400 pointer-events-none" />
    </span>
  );
}
